import { render, staticRenderFns } from "./UsergroupPoGroup.vue?vue&type=template&id=ccdb9fc8"
import script from "./UsergroupPoGroup.vue?vue&type=script&lang=js"
export * from "./UsergroupPoGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports